<template>
  <apexchart
    type="line"
    :options="chartOptions"
    :series="updatedSeries"
    height="350"
    class="line-chart-mobile"
  />
</template>

<script>
  import { toFixed, round } from '../../../utils/ramda-utils'
  import { pathOr, compose, converge, reduce, head, identity, max, prop, map, propOr, over, lensProp } from 'ramda'
  import { BLUE } from '../../../constants/charts'

  export default {
    props: {
      series: {
        type: Array,
        default: () => [],
      },
      labels: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      updatedSeries() {
        return compose(
          map(over(lensProp('name'), (name) => this.$t(`charts.${name}`))),
          propOr([], 'series')
        )(this)
      },
      dataSeries: pathOr([], ['series', 0, 'data']),
      maxValue: compose(
        converge(
          reduce(max),
          [
            head,
            identity
          ]
        ),
        prop('dataSeries')
      ),
      numberOfTicks() {
        const ticks = this.maxValue < 6 ? round(this.maxValue) : 6
        return ticks
      },
      chartOptions() {
        return {
          chart: {
            animations: {
              enabled: true,
            },
            toolbar: {
              show: false,
            }
          },
          stroke: {
            curve: 'straight'
          },
          colors: [ BLUE ],
          dataLabels: {
            enabled: true,
            formatter: toFixed(0)
          },
          xaxis: {
            type: 'category',
            categories: this.labels,
            labels: {
              show: true,
            }
          },
          yaxis: {
            labels: { formatter: toFixed(0) },
            tickAmount: this.numberOfTicks,
            max: () => this.maxValue * 1.05,
          },
          states: {
            hover: {
              filter: {
                type: 'none'
              }
            }
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.line-chart-mobile {
  min-width: 600px;
}
</style>
